import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-address-field-replace',
  templateUrl: './address-field-replace.component.html',
  imports: [
    ReactiveFormsModule
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldReplaceComponent implements OnInit {
  @Input() fieldControl: FormControl;

  constructor() {
  }

  ngOnInit(): void {
  }

}
